import { AnyAction } from 'redux';
import { VARIANT_UPDATED } from '../constants';

interface SelectedVariantState {
  variantId?: any;
  size?: any;
}

const DEFAULT_STATE: SelectedVariantState = {
  variantId: '',
  size: '',
};

export default (
  state = DEFAULT_STATE,
  action: AnyAction
): SelectedVariantState => {
  switch (action.type) {
    case VARIANT_UPDATED:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
